import { DR_HATCHES, HatchName } from "./hatch-list";

export type HatchPatternWithName = {
  name: HatchName;
  baseScale?: number; // initial scale factor applied to the hatch. It must be defined for height of 1. Then, another scale is applied depending on selected scale of text.
};

export default class HatchLibrary {
  static getByName(name: string): HatchPatternWithName | undefined {
    // clone object to keep a neat source object
    return structuredClone(DR_HATCHES.find((h) => h.name === name));
  }
}
